<template>
  <el-dialog
    :title="manageUsersModal.usersTypeChangingState === 'users' ? 'Пользователи группы' : 'Соавторы группы'"
    :visible.sync="manageUsersModal.show"
    width="70%"
    :close-on-click-modal="false"
  >
    <div
      v-if="manageUsersModal.groupType === $constants.group.types.TYPE_DYNAMIC"
      style="margin-bottom: 50px"
    >
      <div style="font-size: 20px">Условия добавления пользователей в группу</div>
      <entity-saved-report-form
        style="margin-top: -30px"
        :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_GROUP_USERS"
        :entity-id="manageUsersModal.groupId"
        entity-report-key="users"
        delete-on-empty-search
      ></entity-saved-report-form>
      <el-button
        style="width: 100%"
        type="default"
        size="mini"
        icon="fas fa-sync"
        @click="recountDynamicUsers"
      >
        Пересчитать пользователей
      </el-button>
    </div>

    <el-row style="margin-bottom: 10px">
      <users-table
        :loading="manageUsersModal.loading"
        :users.sync="manageUsersModal.users"
        :add-button="manageUsersModal.usersTypeChangingState !== 'users' || manageUsersModal.groupType === $constants.group.types.TYPE_STATIC"
        search-field
        add-button-type="primary"
        @search="manageUsersModalSearchChanged"
        @page-changed="manageUsersModalPageChanged"
        @user-deleted="manageUsersModalUserDeleted"
        @users-added="manageUsersModalUsersAdded"
      ></users-table>

      <paginator
        :paginator.sync="paginator"
        @page-changed="manageUsersModalUsersSearch"
      ></paginator>
    </el-row>

    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="manageUsersModal.show = false">Закрыть</el-button>
      </span>
  </el-dialog>
</template>

<script>

import {off, on} from "element-ui/src/utils/dom";
import {paginator} from "@/mixins/paginator";
import Paginator from "@/components/Paginator";
import CardsComponent from "@/components/cards/CardsComponent";
import UsersTable from "@/components/user/UsersTable.vue";
import EntitySavedReportForm from "@/components/report/builder/EntitySavedReportForm.vue";

export default {
  name: "group-users-dialog",
  components: { EntitySavedReportForm, UsersTable, CardsComponent, Paginator},
  mixins: [paginator],
  props: {
    // manageUsersModal: {type: Object}
  },

  data() {
    return {
      // show: false,
      loading: false,

      manageUsersModal: {
        usersTypeChangingState: null, // Какое модальное сейчас открыто
        show: false,
        loading: false,
        groupId: null,
        groupType: null,
        search: null,
        page: 1,
        users: [],
        paginator: null,
      },
    }
  },

  watch: {},
  methods: {
    manageUsersModalShow(groupId, groupType, state) {
      this.manageUsersModal.usersTypeChangingState = state;
      this.manageUsersModal.groupId = groupId;
      this.manageUsersModal.groupType = groupType;
      this.manageUsersModal.search = null;
      this.manageUsersModal.show = true;
      this.manageUsersModal.paginator = null;
      this.manageUsersModal.users = [];
      // this.paginator.page =1;
      this.paginatorReset()
      this.manageUsersModalUsersSearch();
    },
    manageUsersModalUsersSearch() {
      this.manageUsersModal.loading = true;
      const method = this.manageUsersModal.usersTypeChangingState === 'users' ? this.$api.user.search : this.$api.group.getCoauthors;
      method({
        group_ids: [this.manageUsersModal.groupId],
        search: this.manageUsersModal.search,

        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.manageUsersModal.users = data.users;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.manageUsersModal.loading = false;
        })
    },
    manageUsersModalSearchChanged(search) {
      this.manageUsersModal.search = search;
      this.manageUsersModalUsersSearch();
    },
    manageUsersModalPageChanged(page) {
      this.manageUsersModal.page = page;
      this.manageUsersModalUsersSearch();
    },

    manageUsersModalUsersAdded(users) {
      let ids = users.map(user => user.id);
      this.manageUsersModal.loading = true;
      this.$api.group.addUsersToGroup({
        type: this.manageUsersModal.usersTypeChangingState,
        group_id: this.manageUsersModal.groupId,
        user_ids: ids
      })
        .then(data => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Пользователи успешно добавлены'
          });
        })
        .finally(() => {
          this.manageUsersModalUsersSearch();
        })
    },
    manageUsersModalUserDeleted(user) {
      this.manageUsersModal.loading = true;
      this.$api.group.deleteUsersFromGroup({
        type: this.manageUsersModal.usersTypeChangingState,
        group_id: this.manageUsersModal.groupId,
        user_ids: [user.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Пользователь успешно удален из группы'
          });
        })
        .finally(() => {
          this.manageUsersModal.loading = false;
        })
    },

    recountDynamicUsers() {
      this.manageUsersModal.loading = true;
      this.$api.group.recountDynamicUsers({
        id: this.manageUsersModal.groupId,
      })
        .then(data => {
          this.$notify.success({
            title: 'Выполнено',
            message: 'Пользователи успешно пересчитаны'
          });
        })
        .finally(() => {
          this.manageUsersModalUsersSearch();
        })
    },
  },


}
</script>

<style>

</style>